module.exports = __webpack_public_path__ + "img/LUB00418.a3e9b7fc.png";